import React, {Fragment} from 'react';

const useNewLineText = (text: string | React.ReactFragment) => {
  if (!text) {
    return '';
  }

  if (typeof text !== 'string') {
    return text;
  }

  return text.split(/\n|\\n/).map((line: string, index: number) => (
    <Fragment key={index}>
      {index > 0 && <br />} {line}
    </Fragment>
  ));
};

export default useNewLineText;
